import { render, staticRenderFns } from "./UISimplePortfolioCard.vue?vue&type=template&id=9a6d2dce"
import script from "./UISimplePortfolioCard.vue?vue&type=script&lang=js"
export * from "./UISimplePortfolioCard.vue?vue&type=script&lang=js"
import style0 from "./UISimplePortfolioCard.vue?vue&type=style&index=0&id=9a6d2dce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileImg: require('/skade-pwa/components/ui/atom/ProfileImg.vue').default})
